import { render, staticRenderFns } from "./PracticeOrderStart.vue?vue&type=template&id=04bcd91c&scoped=true"
import script from "./PracticeOrderStart.vue?vue&type=script&lang=js"
export * from "./PracticeOrderStart.vue?vue&type=script&lang=js"
import style0 from "./PracticeOrderStart.vue?vue&type=style&index=0&id=04bcd91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcd91c",
  null
  
)

export default component.exports